<!--  用户所在区域下属所有区域-->
<template>
  <el-select
    v-model="selectID"
    :disabled="disabled"
    placeholder="请选择归属区域"
    filterable
    remote
    :remote-method="remoteFilterArea"
    class="common-width"
    @change="handleSelectChange"
    ref="areaSelect"
    clearable
    :value-key="treeProps.value"
  @clear="handleSelectClear"
  >
  <el-option
    :value="selectID"
    :label="selectAreaName"
    style="height: 300px; overflow-y: auto; padding: 0;"
  >
    <el-tree
      ref="areaTree"
      :data="options_area"
      :props="treeProps"
      :default-expand-all="true"
      :check-strictly="true"
      :node-key="treeProps.value"
      :highlight-current="true"
      @node-click="handleNodeClick"
      class="area-tree"
    ></el-tree>
  </el-option>
  </el-select>
</template>

<script>
import { treeDataTranslate } from '@/utils'

export default {
  name: 'area-use',
  data() {
    return {
      selectID: this.id || '',
      selectAreaName: '', // 存储选中的区域名称（用于回显）
      treeProps: {
        value: 'id',
        children: 'children',
        label: 'areaName'
      },
      options_area: [],
      originAreaData: [], // 原始数据备份
      searchKeyword: ''   // 搜索关键词缓存
    }
  },
  props: {
    id: [String, Number],
    parentId: {
      type: [Number, String],
      default: null
    },
    level: String,
    parentIdPath: String,
    disabled: Boolean
  },
  watch: {
    id: {
      handler(newVal) {
        this.selectID = newVal || '';
        // 同步回显名称 + 树形高亮
        this.$nextTick(() => {
          this.updateSelectName(newVal); // 更新回显名称
          if (this.$refs.areaTree && newVal) {
            this.$refs.areaTree.setCurrentKey(newVal);
          }
        });
      },
      immediate: true
    },
    parentId: {
      handler() {
        this.getBankCondition();
      },
      immediate: true
    }
  },
  created() {
    this.getBankCondition();
  },
  methods: {
    // 新增：处理select清空事件（核心修复）
    handleSelectClear() {
      // 1. 清空关键词
      this.searchKeyword = '';
      // 2. 重置过滤数据为全部
      this.options_area = JSON.parse(JSON.stringify(this.originAreaData));
      // 3. 清空回显名称
      this.selectAreaName = '';
      // 4. 清空树形节点高亮
      if (this.$refs.areaTree) {
        this.$refs.areaTree.setCurrentKey(null);
      }
      // 5. 触发父组件事件，同步清空id
      this.$emit("update:id", '');
      this.$emit('select', '');
    },

    // 根据ID查找区域名称（核心回显逻辑）
    updateSelectName(areaId) {
      if (!areaId || !this.originAreaData.length) {
        this.selectAreaName = '';
        return;
      }
      // 递归查找树形数据中对应ID的节点
      const findNodeName = (tree, id) => {
        for (const node of tree) {
          if (node.id == id) {
            return node.areaName;
          }
          if (node.children && node.children.length) {
            const childName = findNodeName(node.children, id);
            if (childName) return childName;
          }
        }
        return '';
      };
      this.selectAreaName = findNodeName(this.originAreaData, areaId);
      // 同步到select的显示标签（兼容低版本Element UI）
      if (this.$refs.areaSelect) {
        this.$refs.areaSelect.selectedLabel = this.selectAreaName;
      }
    },

    // 树形节点点击 - 核心选中逻辑
    handleNodeClick(nodeData) {
      this.selectID = nodeData.id;
      this.selectAreaName = nodeData.areaName; // 同步名称
      // 手动关闭下拉框
      this.$refs.areaSelect.visible = false;
      // 触发原有emit事件
      this.$emit('select', nodeData.id);
      this.$emit("update:id", nodeData.id);
      this.$emit("update:level", nodeData.level);
      this.$emit("update:parentIdPath", nodeData.parentIdPath);
    },

    // select change事件（兼容）
    handleSelectChange(val) {
      if (!val) {
        this.selectAreaName = '';
        return;
      }
      this.updateSelectName(val); // 同步名称
      this.handleNodeClick({ id: val });
    },

    // 远程过滤方法（替代filter-method，兼容性更好）
    remoteFilterArea(keyword) {
      this.searchKeyword = keyword.trim().toLowerCase();
      this.filterAreaData();
    },

    // 核心过滤逻辑（抽离成独立方法）
    filterAreaData() {
      if (!this.searchKeyword) {
        // 无关键词恢复原始数据
        this.options_area = JSON.parse(JSON.stringify(this.originAreaData));
        return;
      }
      // 递归过滤树形数据
      const filterNode = (tree) => {
        return tree.map(node => {
          // 深拷贝节点，避免修改原始数据
          const newNode = { ...node };
          // 递归处理子节点
          if (newNode.children && newNode.children.length) {
            newNode.children = filterNode(newNode.children);
          }
          return newNode;
        }).filter(node => {
          // 匹配当前节点名称（兼容null）
          const isMatch = node.areaName ? node.areaName.toLowerCase().includes(this.searchKeyword) : false;
          // 子节点有匹配结果也保留父节点
          const hasChildMatch = node.children && node.children.length > 0;
          return isMatch || hasChildMatch;
        });
      };
      this.options_area = filterNode(JSON.parse(JSON.stringify(this.originAreaData)));
    },

    // 加载区域数据（修复数据初始化问题）
    getBankCondition() {
      this.$http({
        url: this.$http.adornUrl('/sys/area/getSupportAreas'),
        method: 'get',
        params: this.$http.adornParams(this.parentId ? { parentId: this.parentId } : {})
      }).then(({ data }) => {
        if (data && data.code === 0) {
          // 格式化树形数据并备份
          this.originAreaData = treeDataTranslate(data.data, "id", "parentId");
          // 初始化过滤后的数据
          this.options_area = JSON.parse(JSON.stringify(this.originAreaData));
          // 校验选中值有效性并更新回显名称
          const current = data.data.find(item => item.id == this.id);
          if (!current) {
            this.id = '';
            this.selectAreaName = '';
            this.$emit("update:id", '');
          } else {
            this.selectAreaName = current.areaName; // 初始化回显名称
            // 延迟高亮，确保DOM渲染完成
            this.$nextTick(() => {
              if(this.$refs.areaTree) {
                this.$refs.areaTree.setCurrentKey(this.id);
              }
              if(this.$refs.areaSelect) {
                this.$refs.areaSelect.selectedLabel = current.areaName;
              }
            });
          }
        }
      }).catch((err) => {
        console.error('加载区域数据失败：', err);
      });
    }
  }
}
</script>

<!-- 强制样式适配，解决显示问题 -->
<style scoped>
/* 修复select下拉项样式 */
:deep(.el-select-dropdown__item) {
  height: auto !important;
  padding: 0 !important;
  line-height: normal !important;
}
/* 树形结构样式优化 */
:deep(.area-tree) {
  padding: 8px;
  font-size: 14px;
}
/* 修复选中节点高亮 */
:deep(.el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content) {
  background-color: #e5f5ff !important;
  color: #1989fa !important;
}
/* 修复搜索框显示 */
:deep(.el-select .el-input__inner) {
  padding-right: 35px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/area/area-use.vue